<app-header></app-header>
<section class="container-xxl">
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
            <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                <div [style]="navmenuloadCss">
                    <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                  </div>
            </div> 
            <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->


    <div class="inner-page-sidedetails">
        <div id="section-New"></div>
        <div class="inner-banner-image">
            <div class="image-area">
                <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
            </div>
        </div>
        <div class="details">
            <div class="title">
                <h2 class="screen-reader">{{ 'BoardOfDirectors' |translate }}</h2>
            </div>
            <div class="description">
                <div class="news mb-4">
                    <div
                        class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4  row-cols-xxl-5 g-3 magazine-grid">
                        <ng-container *ngFor="let item of directoryList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">
                            <div class="col">
                                <div class="card">
                                    <div class="card-body text-center">
                                        <div class="magazine-image">
                                            <div class="st-name screen-reader"  *ngIf="checkFile(item)==false"> 
                                            <ng-container *ngIf="language=='English'">
                                                {{ item.fullName | shortName }} 
                                            </ng-container>
                                            <ng-container *ngIf="language=='Hindi'">
                                                {{item.fullNameInHindi | shortName }} 
                                            </ng-container>
                                            </div>

                                            <img class="screen-reader" [src]="backend_url+'storage/app/uploads/'+item.profileImage"
                                                *ngIf="checkFile(item)==true" alt="upload_image">
 
                                        </div>
                                        <div class="magazine-txt screen-reader"> {{ language=='English'?item.fullName:item.fullNameInHindi }} </div>
                                        <p class="mb-1 font-adjust screen-reader"> {{ htmlTag(language=='English'?item.designation:item.designationInHindi) }}</p>
                                        
                                        <small class="mb-1">
                                            <span *ngFor="let email of item.addEmailId; let i=index">
                                                <a class="screen-reader" href="mailto:{{ email.emailId }}" [attr.title]="language=='English'?'E-mail':'ई-मेल'"> <i
                                                        class="bi bi-envelope me-1 font-adjust"></i>
                                                    {{ email.emailId | mailView }} 
                                                    <ng-container
                                                        *ngIf="item.addEmailId.length != (i+1)"><br></ng-container>
                                                </a>
                                            </span>
                                        </small>
                                        <small class="text-muted mb-1">
                                            <span *ngFor="let contact of item.contactNumber; let i=index">
                                                <a class="screen-reader" href="tel: {{ contact.phoneNumber }}" [attr.title]="language=='English'?'Phone No.':'फोन नंबर'"> <i
                                                        class="bi bi-telephone-outbound me-1 font-adjust"></i>
                                                    <ng-container *ngIf="contact.sTDCode != ''">
                                                        {{ language=='English'?contact.sTDCode:contact.sTDCodeInHindi}}-
                                                    </ng-container>
                                                    {{ language=='English'?contact.phoneNumber:contact.phoneNumberInHindi }}
                                                    <ng-container
                                                        *ngIf="item.contactNumber.length != (i+1)"><br></ng-container>
                                                </a>
                                            </span>
                                        </small>
                                        <small class="text-muted screen-reader" *ngIf="encDec.decodeHtml(language=='English'?item.address:item.addressInHindi)!==''">{{'Address'|translate}}: {{
                                            encDec.decodeHtml(language=='English'?item.address:item.addressInHindi)
                                            }}
                                        </small>
                                        <small class="text-muted screen-reader" *ngIf="item.wEF!=='1000-01-01'">{{'WEF'|translate}}: {{item.wEF | date: 'MMM d, y'}} </small> 
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 20"></pagination-controls>
                </div>
            </div>
     </div>
    </div>

    <!-- INNER CONTENT - ENDS -->
</div>
</div>
</div>
</div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>